<script lang="ts" setup>
import { ref, computed, watch } from "vue";
import useMessages from "@/composables/messages.js";
import { appliedStatusColors } from "@/composables/colors";
import AdvancedDoughnutChart from "@/components/app/charts/AdvancedDoughnutChart.vue";

const { msgApplied } = useMessages();

const props = defineProps({
  sourceData: {
    type: Object,
    required: true,
  },
  radius: {
    type: Number,
    default: 150,
  },
  showTotal: {
    type: Boolean,
    default: true,
  },
  chartName: {
    type: String,
    default: null,
  },
  showInnerLabel: {
    type: Boolean,
    default: true,
  },
});

const chart = ref({
  labels: null,
  data: null,
  backgroundColors: null,
});
const options = ref({
  responsive: false,
  maintainAspectRatio: true,
  animation: {
    duration: 2000,
  },
  legend: {
    display: false,
  },
});

const total = ref(0);

const style = computed(() => {
  return {
    width: `${props.radius}px`,
    height: `${props.radius}px`,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
  };
});

const innerLabelText = ref<IInnerChartText[]>([]);

function setInnerLabelText() {
  if (props.showInnerLabel) {
    innerLabelText.value = [
      { value: "Totaal", bold: false },
      { value: total.value, bold: true },
      { value: "maatregelen", bold: false },
    ];
  } else {
    innerLabelText.value = null;
  }
}

watch(
  () => props.sourceData,
  () => {
    let backgroundColors = [];
    let labels = [];

    Object.keys(props.sourceData).forEach((data) => {
      backgroundColors.push(appliedStatusColors[data] ? appliedStatusColors[data] : "#CCCCCC");
      labels.push(msgApplied(data));
    });

    chart.value.backgroundColors = backgroundColors;
    chart.value.labels = labels;
    chart.value.data = Object.values(props.sourceData);

    total.value = Object.values(props.sourceData).reduce((a: number, b: any) => a + Number(b), 0);
    setInnerLabelText();
  },
  { immediate: true, deep: true }
);
</script>

<template>
  <div class="vue-chart building-measures">
    <AdvancedDoughnutChart
      :innerText="innerLabelText"
      :key="chartName ? `doughnutChart${props.chartName}` : 'doughnutChartAppliedStatus'"
      :chartName="chartName ? props.chartName : 'AppliedStatus'"
      :data-set="chart"
      :options="options"
      :style="style"
    ></AdvancedDoughnutChart>
  </div>
</template>
